import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import GridLayout from "../../components/GridLayout"
import PageLayout from "../../components/PageLayout"
import GridTextProjectElement from "../../components/GridTextProjectElement"
import { projectNames } from "../../context/consts"
import Seo from "../../components/Seo"


const SmartRobotsHead = () => {

    const imageComponents = [
        <StaticImage key={0} src="./../../images/smart-robots/smart-robots-0.jpg" alt="" layout="fullWidth"></StaticImage>,
        <GridTextProjectElement key={1}  projectName={projectNames.SMART_ROBOTS} />,
        <StaticImage key={2} src="./../../images/smart-robots/smart-robots-1.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={3} src="./../../images/smart-robots/smart-robots-2.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={4} src="./../../images/smart-robots/smart-robots-3.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={5} src="./../../images/smart-robots/smart-robots-4.jpg" alt="" layout="fullWidth"></StaticImage>,
    ]

    return (
        <PageLayout firstHead="smartrobots" secondHead="controlhead">
            <GridLayout components={imageComponents}></GridLayout>
            <Seo subTitle="smartrobots controlhead" />
        </PageLayout>
    )

}

export default SmartRobotsHead